export default "__VITE_ASSET__8a271a97__"